/* unplugin-vue-components disabled */import { render } from "./remove-item-modal.vue?vue&type=template&id=0bb3e4e8"
import script from "./remove-item-modal.vue?vue&type=script&lang=js"
export * from "./remove-item-modal.vue?vue&type=script&lang=js"

import "./remove-item-modal.vue?vue&type=style&index=0&id=0bb3e4e8&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__